<template>
  <div class="pa-4 d-flex align-center">
    <v-icon small color="error">mdi-alert</v-icon>
    <span class="pl-4 red--text text-subtitle-2">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  name: 'DuaMessageError',

  props: {
    errorMessage: String
  }
}
</script>
